import { render, staticRenderFns } from "./prescripteur_add.vue?vue&type=template&id=e4de58e2&"
import script from "./prescripteur_add.vue?vue&type=script&lang=js&"
export * from "./prescripteur_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports